import { render, staticRenderFns } from "./select-balance-type.vue?vue&type=template&id=4c5d0094"
import script from "./select-balance-type.vue?vue&type=script&lang=ts"
export * from "./select-balance-type.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports